
















import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

@Component
export default class TooltipButton extends Vue {
	@Prop({ required: true, type: Boolean })
	public disabled!: boolean;

	@Prop({ required: true, type: String })
	public tooltipText!: string;

	@Prop({ required: true, type: String })
	public buttonText!: string;

	@Prop({ type: Boolean, default: false })
	public loading: boolean;

	@Prop({ type: String, default: 'success' })
	public variant: boolean;

	@Prop({ type: String, default: 'sm' })
	public size: boolean;

	@Prop({ type: String, default: '' })
	public classes: boolean;

	@Prop({ type: String, default: '' })
	public iconAnimation: boolean;

	@Prop({ type: String })
	public icon!: string;

	@Emit('click')
	public emitClick(e: Event): Event {
		return e;
	}

	public onClick(e: Event) {
		if (!this.disabled) {
			this.emitClick(e);
		}
	}
}
